import { Service } from '../Service';
import apiRequestService from '../api/apiRequestService';
import { Method } from '../http/types';

import { UserSetting, UserSettingsTypes } from './types';
import parseSettings from './utils/parseSettings';
import { VALIDATION_SCHEMAS } from './schemes';
import stringifyData from './utils/stringifyData';

type SetUserSettingsServicePayload = UserSettingsTypes;

const setUserSettingsService: Service<
  SetUserSettingsServicePayload,
  string | null | object
> = ({ name, value = null }) =>
  new Promise((resolve, reject) => {
    try {
      VALIDATION_SCHEMAS[name].validateSync({ name, value });
    } catch (e) {
      console.error('setUserSettingsService', name, e);
      reject(e);
    }

    return apiRequestService<{ settings: UserSetting }>({
      httpMethod: Method.Post,
      method: '/userSettings',
      body: { name, value: stringifyData(value) },
    }).then(({ settings }) => {
      if (!settings || settings.value === null) {
        const error = new Error(`No ${name} found in user settings`);

        reject(error);
        console.error('setUserSettingsService', error);
      }

      resolve(
        parseSettings(
          settings as UserSetting<string>,
          typeof value === 'object' ? 'json' : 'text',
        ),
      );
    });
  });

export default setUserSettingsService;
